import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  useMediaQuery,
  Grid2,
  Divider,
  Pagination,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import { Paginated, RequestError, useApi } from "../../services";
import { ErrorOnDialog, GISTMCheckItem } from "../../components";
import { GISTMChecklist as CheckListItem } from "../../services/api/gistm";

export const GISTMChecklist: React.FC = () => {
  const api = useApi();
  const theme = useTheme();
  const { barragem } = useParams<{ barragem: string; }>();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down(1100));

  const [error, setError] = useState<RequestError>();
  const [checklist, setChecklist] = useState<Paginated<CheckListItem>>({
    items: [],
    page: 1,
    perPage: 50,
    totalItems: 0,
    totalPages: 1,
  });

  useEffect(() => {
    if (!barragem) return;
    api.gistm.getAllChecklist(parseInt(barragem), checklist.page, checklist.perPage).then(val => {
      if ("error" in val) {
        setError(val);
        return;
      }
      setChecklist(val);
    });
  }, [checklist.page, checklist.perPage]);

  return (
    <>
      {error && <ErrorOnDialog
        error={error.error}
        open={Boolean(error)}
        message={error.message}
        onClose={() => setError(undefined)}
      />}

      <Box sx={{ p: 2, height: "100%", width: "100%", flex: 3, display: "flex", flexDirection: "column", alignItems: "center", gap: "15px" }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, display: { xs: "none", sm: "block" } }}
        >
          Checklist de Ações
        </Typography>

        <Divider flexItem />

        <Box sx={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", gap: "10px", overflowY: "auto" }}>
          <Grid2
            container
            spacing={2}
            sx={{ width: "100%", height: "100%" }}
          >
            {checklist.items.map((check, index) => (
              <Grid2 size={isMobileOrTablet ? 12 : 6} key={index}>
                <GISTMCheckItem key={check.id} checkData={check} />
              </Grid2>
            ))}
          </Grid2>
        </Box>


        {/* Paginação */}
        <Pagination
          showFirstButton showLastButton
          size="small"
          page={checklist.page}
          count={checklist.totalPages}
          onChange={(_, value) => setChecklist({ ...checklist, page: value })}
        />
      </Box >
    </>
  );
};
